import { Add } from "@mui/icons-material";
import { Card, Grid } from "@mui/material";
import { useEffect, useState, useMemo } from "react";

import Box from "../../components/Box";
import Helpers from "../../commons/helpers";
import Avatar from "../../components/Avatar";
import Button from "../../components/Button";
import ControlChip from "../../components/Chip";
import useStrings from "../../hooks/useStrings";
import DataTable from "../../components/DataTable";
import FormField from "../../components/FormField";
import Typography from "../../components/Typography";
import Autocomplete from "../../components/Autocomplete";
import useContainerStaff from "../../hooks/useContainerStaff";
import useContainerGroup from "../../hooks/useContainerGroup";
import useContainerInvitation from "../../hooks/useContainerInvitation";
import ModalInvitationMember from "../../components/Staff/modalInvitationMember";
import ModalHandelDeleteMember from "../../components/Staff/modalHandelDeleteMember";
import CustomStatusCell, { StatusByScreen } from "../../components/CustomStatusCell";
import UserService, { IRequestGetPagedUser } from "../../services/identity/user.service";

import { MainComponent } from "../main";
import { commonGetAllDataRole } from "../role/list";
import { Constants } from "../../constants/constants";
import { RoleHelpers } from "../../commons/roleHelpers";
import { GroupType, Mode, Status } from "../../constants/enums";
import { useCommonComponentContext } from "../../providers/CommonComponentProvider";
import { ICodename, ILableOrganization, IPropListContainer } from "../../commons/interfaces";


// // //
interface IListUserProps {
    id: string;
    email?: string;
    userCode: string;
    fullName?: string;
    avatarId?: string;
    avatarUrl?: string;
    phoneNumber?: string;
    invitationId: string;
    userRoles?: string[];
    userGroups?: string[];
    arrRoleTypes: number[],
    organizationId?: string;
    status?: any;
}

interface IModel {
    requestData?: IRequestGetPagedUser;
    requestDataTemp?: IRequestGetPagedUser;
}

type IProps = IPropListContainer<IRequestGetPagedUser> & ILableOrganization & {
    title?: string,
    newDomain?: string,

    hidenActionUpdate?: boolean,
    hidenActionDelete?: boolean,
    hidenActionCreate?: boolean,
    hidenActionInvitation?: boolean,
    hidenActionDeleteAllService?: boolean,

    modalCreateMember?: (props: {
        groupId?: string;
        organizationId: string;
        onCallBack?: () => void;
    }) => JSX.Element;

    modalInvitationMember?: (props: {
        groupId?: string;
        organizationId: string;
        onCallBack?: () => void;
    }) => JSX.Element;
}
// // //


const StaffListContainer = ({
    title,
    newDomain,
    lableStaff,
    lableGroup,
    requestGetPaged,
    lableOrganization,

    hidenActionDelete,
    hidenActionUpdate,
    hidenActionCreate,
    hidenActionInvitation,
    hidenActionDeleteAllService,

    modalCreateMember,
    modalInvitationMember,

    onNavigate,
    onGetPaged,
}: IProps) => {

    const strings = useStrings();

    const { onChangeStatusMember } = useContainerStaff();
    const { onResendInvitation } = useContainerInvitation();
    const { checkGeneByGroup, getAllDataGroup } = useContainerGroup();

    const {
        clientId,
        language,
        userInfo,
        onError,
        onShowLoading,
        onHideLoading,
    } = useCommonComponentContext();

    const [dataRows, setDataRows] = useState<any[]>([]);
    const [model, setModel] = useState<IModel>({} as IModel);
    const [roleList, setRoleList] = useState<ICodename[]>([]);
    const [groupList, setGroupList] = useState<ICodename[]>([]);
    const [userIdDelete, setUserIdDelete] = useState<string>("");
    const [loadingDataTable, setLoadingDataTable] = useState<boolean>(false);

    const listStatusStaff: ICodename[] = useMemo(() => [
        { code: Status.Active, name: strings.Common.ACTIVE, },
        { code: Status.Decline, name: strings.Common.REJECTED, },
        { code: Status.Inactive, name: strings.Common.IN_ACTIVE, },
        { code: Status.PendingInvitation, name: strings.Common.PENDING_INVITATION, },
    ], [strings]);

    const newLableStaff = useMemo(() => (
        (lableStaff || strings.Common.STAFF).toLowerCase()
    ), [lableStaff, strings]);

    const newLableGroup = useMemo(() => (
        (lableGroup || strings.Common.GROUP).toLowerCase()
    ), [lableGroup, strings]);

    useEffect(() => { onStarted(); }, [requestGetPaged, userInfo?.userProfile?.organizationId]);

    const onStarted = async () => {
        try {
            // onShowLoading();
            setLoadingDataTable(true);

            const newDataReq: IRequestGetPagedUser = {
                totalCount: requestGetPaged?.totalCount,
                orderby: requestGetPaged?.orderby || model?.requestData?.orderby,
                pageSize: requestGetPaged?.pageSize || model?.requestData?.pageSize,
                pageNumber: requestGetPaged?.pageNumber || model?.requestData?.pageNumber,
                listStatus: requestGetPaged?.listStatus || model?.requestData?.listStatus,
                searchText: requestGetPaged?.searchText || model?.requestData?.searchText,
                roleCode: requestGetPaged?.roleCode || model?.requestData?.roleCode,
                groupId: requestGetPaged?.groupId || model?.requestData?.groupId,
            };

            const listRoleTemp: ICodename[] = await commonGetAllDataRole({
                clientId: clientId,
                status: Status.Active,
                organizationId: userInfo?.userProfile?.organizationId,
            });

            let listGroupTemp: ICodename[] = [];
            const resultGetAllGroup = await getAllDataGroup({
                clientId: clientId,
                listStatus: [Status.Active],
                organizationId: userInfo?.userProfile?.organizationId,
            });
            [...resultGetAllGroup || []].forEach(item => {
                if (Number(item.detail?.type) !== GroupType.Company) {
                    const checkGeneItem = checkGeneByGroup({
                        gene: item.detail?.gene,
                        listGroupSlice: userInfo?.listGroup,
                        roleType: userInfo?.userProfile?.roleType,
                        organizationId: userInfo?.userProfile?.organizationId,
                    });
                    checkGeneItem && listGroupTemp.push({
                        ...item,
                        name: Helpers.renderValueByLanguage({ data: item.name, currentLanguage: language }),
                    });
                }
            });

            setRoleList(listRoleTemp);
            setGroupList(listGroupTemp);

            await getPagedUser(newDataReq);

        } catch (error: any) {
            const e = Helpers.renderExceptionError(error);
            onError(e);
        } finally {
            // onHideLoading();
            setLoadingDataTable(false);
        }
    };

    const getPagedUser = async (newDataReq?: IRequestGetPagedUser) => {
        try {
            // onShowLoading();
            setLoadingDataTable(true);

            const pageSize = newDataReq?.pageSize || Constants.ROW_PER_PAGE;
            const pageNumber = Helpers.getPageNumber(newDataReq?.pageNumber || 1, pageSize, newDataReq?.totalCount || 0);

            let userList: IListUserProps[] = [];

            const reqTemp: any = {
                ...newDataReq,

                pageSize,
                pageNumber: pageNumber || 1,

                clientId: clientId,
                organizationId: userInfo?.userProfile?.organizationId,
            };

            const resultGetPaged = await UserService.getPaged(reqTemp);

            [...resultGetPaged.items || []].forEach((item: any) => {
                const userRoles: string[] = [...item?.userRoles || []].map((el: any) => (el?.roleName));
                const userGroups: string[] = [...item?.groupUsers || []].map((el: any) => Helpers.renderValueByLanguage({ data: el.groupName, currentLanguage: language }));
                const userInvitationGroups: string[] = [...item?.invitation?.groupNames || []].map((el: any) => Helpers.renderValueByLanguage({ data: el, currentLanguage: language }));

                const arrRoleTypes: number[] = [...item?.userRoles || []].map((el: any) => RoleHelpers.getRole(Number(el.roleType)).roleDetailType);

                let fullName = item.fullName || item.userName;
                if (!Helpers.isNullOrEmpty(item.organizationUserProfile?.firstName)
                    || !Helpers.isNullOrEmpty(item.organizationUserProfile?.lastName)) {
                    fullName = `${item.organizationUserProfile?.lastName || ""} ${item.organizationUserProfile?.firstName || ""}`.trim();
                }

                userList.push({
                    id: item.id,
                    fullName: fullName,
                    invitationId: item.invitation?.id,
                    email: item.organizationUserProfile?.email,
                    userCode: item.organizationUserProfile?.userCode,
                    phoneNumber: item.organizationUserProfile?.phoneNumber,
                    organizationId: item.organizationUserProfile?.organizationId,

                    avatarId: item.avatarId,
                    avatarUrl: item.avatarUrl,
                    arrRoleTypes: arrRoleTypes,
                    userGroups: !Helpers.isNullOrEmpty(item.invitation) ? userInvitationGroups : userGroups,
                    userRoles: !Helpers.isNullOrEmpty(item.invitation) ? item?.invitation?.roleNames : userRoles,
                    status: item.organizationUserProfile?.status,
                });
            });

            setModel({
                requestData: {
                    ...newDataReq,
                    pageSize: resultGetPaged?.pageSize,
                    pageNumber: resultGetPaged?.currentPage,
                    totalCount: resultGetPaged?.totalCount,
                },
                requestDataTemp: {
                    ...newDataReq,
                    pageSize: resultGetPaged?.pageSize,
                    pageNumber: resultGetPaged?.currentPage,
                    totalCount: resultGetPaged?.totalCount,
                },
            });

            let query: string = `?pageNumber=${pageNumber}&pageSize=${pageSize}`;
            if (!Helpers.isNullOrEmpty(newDataReq?.roleCode)) {
                query += `&roleCode=${newDataReq?.roleCode}`;
            }
            if (!Helpers.isNullOrEmpty(newDataReq?.groupId)) {
                query += `&groupId=${newDataReq?.groupId}`;
            }
            if (newDataReq?.listStatus?.length > 0) {
                newDataReq?.listStatus.forEach(str => {
                    query += `&listStatus=${str}`;
                });
            }
            if (!Helpers.isNullOrEmpty(newDataReq?.searchText)) {
                query += `&searchText=${newDataReq?.searchText}`;
            }

            setDataRows(userList);

            onGetPaged({ query, totalCount: resultGetPaged.totalCount });
        } catch (error) {
            const e = Helpers.renderExceptionError(error);
            onError(e);
        } finally {
            // onHideLoading();
            setLoadingDataTable(false);
        }
    };

    const onChangeValue = (newValue: any, key: string) => {
        setModel(prev => ({
            ...prev,
            requestDataTemp: {
                ...prev.requestDataTemp,
                [key]: newValue,
            }
        }));
    };

    const CardFilterForm = () => (
        <Box>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <FormField
                        maxLength={255}
                        defaultValue={model.requestDataTemp?.searchText}
                        onBlur={(value: any) => onChangeValue(value, "searchText")}
                        label={strings.format(strings.Staff.SEARCH_TEXT, newLableStaff)}
                        placeholder={strings.format(strings.Staff.ENTER_SEARCH_TEXT, newLableStaff)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Autocomplete
                        isGroupBy
                        data={roleList || []}
                        defaultValue={model.requestDataTemp?.roleCode}
                        label={strings.format(strings.Staff.STAFF_PERMISSION, newLableStaff)}
                        placeholder={strings.format(strings.Staff.SELECT_STAFF_PERMISSION, newLableStaff)}
                        onChange={(value) => onChangeValue(value, "roleCode")}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Autocomplete
                        data={groupList || []}
                        defaultValue={model.requestDataTemp?.groupId}
                        onChange={(value) => onChangeValue(value, "groupId")}
                        placeholder={strings.format(strings.Staff.SELECT_WORK_GROUPS, newLableGroup)}
                        label={Helpers.capitalizeFirstLetter(strings.format(strings.Staff.WORK_GROUPS, newLableGroup))}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Autocomplete
                        multiple
                        data={listStatusStaff || []}
                        label={strings.Common.STATUS}
                        placeholder={strings.Common.STATUS}
                        defaultValue={model.requestDataTemp?.listStatus}
                        onChange={(value) => onChangeValue(value, "listStatus")}
                    />
                </Grid>
            </Grid>
        </Box>
    );

    const CardChipFilter = () => (
        <Box mb={1}>
            {!Helpers.isNullOrEmpty(model.requestData?.roleCode) && (
                <ControlChip
                    label={strings.format(strings.Staff.STAFF_PERMISSION, newLableStaff)}
                    value={(roleList || []).find((el) => el.code === model.requestData?.roleCode)?.name}
                    onDelete={() => {
                        getPagedUser({ ...model.requestData, roleCode: undefined })
                    }}
                />
            )}
            {!Helpers.isNullOrEmpty(model.requestData?.groupId) && (
                <ControlChip
                    value={(groupList || []).find((el) => el.code === model.requestData?.groupId)?.name}
                    label={Helpers.capitalizeFirstLetter(strings.format(strings.Staff.WORK_GROUPS, newLableGroup))}
                    onDelete={() => {
                        getPagedUser({ ...model.requestData, groupId: undefined })
                    }}
                />
            )}
            {(model.requestData?.listStatus?.length > 0) && (
                model.requestData?.listStatus?.map(str => (
                    <ControlChip
                        key={str}
                        label={strings.Common.STATUS}
                        value={(listStatusStaff || []).find((el) => el.code === str)?.name}
                        onDelete={() => {
                            const listTemp = model.requestData?.listStatus?.filter(el => el !== str);
                            getPagedUser({ ...model.requestData, listStatus: listTemp });
                        }}
                    />
                ))
            )}
        </Box>
    );

    const dataColumns = useMemo(() => ([
        {
            Header: strings.Staff.FULL_NAME, accessor: "fullName", width: "250px",
            Cell: (row: any) => (
                <Box display="flex" alignItems="center">
                    <Avatar
                        alt="avt-staff"
                        text={row?.value}
                        src={row?.row?.original?.avatarUrl}
                        sx={{
                            width: "36px",
                            height: "36px",
                            objectFit: "cover",
                            marginRight: "8px",
                            borderRadius: "50%",
                        }}
                    />
                    <Box display="grid">
                        <Typography
                            color="text"
                            variant="caption"
                            fontWeight="medium"
                        >
                            {
                                Helpers.isNullOrEmpty(row?.row?.original?.userCode)
                                    ? `${row?.value}`
                                    : `${row?.row?.original?.userCode} - ${row?.value}`
                            }
                        </Typography>
                        {!Helpers.isNullOrEmpty(row?.row?.original?.phoneNumber) &&
                            <Typography
                                color="secondary"
                                variant="caption"
                            >
                                sđt:&nbsp;{row?.row?.original?.phoneNumber || ""}
                            </Typography>
                        }
                        {!Helpers.isNullOrEmpty(row?.row?.original?.email) &&
                            <Typography
                                color="secondary"
                                variant="caption"
                            >
                                email:&nbsp;{row?.row?.original?.email || ""}
                            </Typography>
                        }
                    </Box>
                </Box>
            ),
        },
        {
            Header: Helpers.capitalizeFirstLetter(strings.format(strings.Staff.WORK_GROUPS, newLableGroup)), accessor: "userGroups",
            Cell: (row: any) => <Box display="grid">
                {
                    [...row.value || []].map((el: any, index: number) => (
                        <Typography
                            color="text"
                            variant="caption"
                            fontWeight="medium"
                            key={`user_groups_${index}`}
                        >
                            {el}
                        </Typography>
                    ))
                }
            </Box>,
        },
        {
            Header: strings.format(strings.Staff.STAFF_PERMISSION, newLableStaff), accessor: "userRoles",
            Cell: (row: any) => <Box display="grid">
                {
                    [...row.value || []].map((el: any, index: number) => (
                        <Typography
                            color="text"
                            variant="caption"
                            fontWeight="medium"
                            key={`user_roles_${index}`}
                        >
                            {el}
                        </Typography>
                    ))
                }
            </Box>,
        },
        {
            Header: strings.Common.STATUS, accessor: "status", width: "170px",
            Cell: (row: any) => (
                <CustomStatusCell
                    status={Number(row?.row.original?.status)}
                    statusByScreen={StatusByScreen.screenStaff}
                />
            ),
        },
    ]), [strings, newLableStaff, newLableGroup]);

    const actionList = (row: any): any => {
        let isEdit = true;
        let isDelete = true;

        if ([...row.arrRoleTypes || []].length > 0) {
            isEdit = Math.min(...row.arrRoleTypes) <= RoleHelpers.getRole(Number(userInfo?.userProfile?.roleType)).roleDetailType;
            isDelete = Math.min(...row.arrRoleTypes) < RoleHelpers.getRole(Number(userInfo?.userProfile?.roleType)).roleDetailType;
        }

        return [
            {
                key: "detail",
                iconName: "view",
                title: strings.Common.VIEW_DETAIL,
                callback: (row: any) => onNavigate({ id: row.id, mode: Mode.View }),
            },

            isEdit &&
            !hidenActionUpdate &&
            {
                key: "edit",
                iconName: "edit",
                title: strings.Common.EDIT,
                callback: (row: any) => onNavigate({ id: row.id, mode: Mode.Update }),
            },

            isDelete &&
            !hidenActionDelete &&
            (row.id !== userInfo?.userProfile?.identityId) &&
            {
                key: "delete",
                iconName: "delete",
                title: strings.Common.DELETE,
                callback: (row: any) => { setUserIdDelete(row.id) },
            },

            isDelete &&
            !hidenActionUpdate &&
            (row.id !== userInfo?.userProfile?.identityId) &&
            (row.status === Status.Active || row.status === Status.Inactive) &&
            {
                key: "inactive",
                iconName: (Number(row.status) === Status.Active) ? "close" : "check",
                title: (Number(row.status) === Status.Active) ? strings.Common.IN_ACTIVE : strings.Common.ACTIVE,
                callback: (row: any) => {
                    onChangeStatusMember({
                        lable: "",
                        onCallBack: () => {
                            getPagedUser(model?.requestData);
                        },
                        params: {
                            id: row.id,
                            status: Number(row.status),
                            clientId: clientId,
                            organizationId: userInfo?.userProfile?.organizationId,
                        }
                    });
                },
            },

            !hidenActionUpdate &&
            (row.id !== userInfo?.userProfile?.identityId) &&
            (row.status === Status.PendingInvitation || row.status === Status.Decline) &&
            {
                key: "resend",
                iconName: "resend",
                title: strings.INVITATION.RESEND_INVITATION,
                callback: (row: any) => {
                    onResendInvitation({
                        id: row.invitationId,
                        onCallBack() {
                            getPagedUser(model?.requestData);
                        },
                    })
                },
            }
        ];
    };

    const RenderCardInvitationMember = (): JSX.Element => (
        modalInvitationMember
            ? modalInvitationMember({
                organizationId: userInfo?.userProfile?.organizationId || "0",
                onCallBack() {
                    getPagedUser(model.requestData)
                },
            })
            : (
                <ModalInvitationMember
                    newDomain={newDomain}
                    lableStaff={lableStaff}
                    lableGroup={lableGroup}
                    lableOrganization={lableOrganization}

                    organizationId={userInfo?.userProfile?.organizationId || "0"}

                    roleList={roleList}
                    groupList={groupList}

                    onCallBack={() => {
                        getPagedUser(model.requestData);
                    }}
                />
            )
    );

    const RenderCardCreateMember = (): JSX.Element => (
        modalCreateMember
            ? modalCreateMember({
                organizationId: userInfo?.userProfile?.organizationId || "0",
                onCallBack() {
                    getPagedUser(model.requestData)
                },
            })
            : (
                <Button onClick={() => onNavigate({ mode: Mode.Create })}>
                    <Add /> &nbsp; {strings.Common.ADD_NEW}
                </Button>
            )
    );

    return (
        <MainComponent>
            <Grid container spacing={2}>

                {
                    (!hidenActionInvitation || !hidenActionCreate || !Helpers.isNullOrEmpty(title)) &&
                    <Grid item xs={12}>
                        <Box sx={{
                            gap: 1,
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "center",
                            justifyContent: !Helpers.isNullOrEmpty(title) ? "space-between" : "end",
                        }}>
                            {
                                !Helpers.isNullOrEmpty(title) &&
                                <Typography variant="h5">{title}</Typography>
                            }
                            {
                                (!hidenActionInvitation || !hidenActionCreate) &&
                                <Box sx={{
                                    gap: 2,
                                    display: "flex",
                                    flexWrap: "wrap",
                                    alignItems: "flex-end",
                                }}>
                                    {
                                        !hidenActionInvitation &&
                                        <RenderCardInvitationMember />
                                    }
                                    {
                                        !hidenActionCreate &&
                                        <RenderCardCreateMember />
                                    }
                                </Box>
                            }
                        </Box>
                    </Grid>
                }

                <Grid item xs={12}>
                    {(
                        (model.requestData?.listStatus?.length > 0) ||
                        !Helpers.isNullOrEmpty(model.requestData?.groupId) ||
                        !Helpers.isNullOrEmpty(model.requestData?.roleCode)
                    ) &&
                        <CardChipFilter />
                    }
                    <Card>
                        <Box p={2}>
                            <DataTable
                                loading={loadingDataTable}
                                rowPerPage={model.requestData?.pageSize}
                                pageNumber={model.requestData?.pageNumber}
                                totalCount={model.requestData?.totalCount || 0}
                                onChangePageSize={(pageSize) => {
                                    getPagedUser({ ...model.requestData, pageSize });
                                }}
                                onChangePageNumber={(pageNumber) => {
                                    getPagedUser({ ...model.requestData, pageNumber });
                                }}

                                searchText={model.requestData?.searchText || ""}
                                onSearchChange={(val) => {
                                    setModel(prev => ({
                                        ...prev,
                                        requestData: {
                                            ...prev.requestData,
                                            searchText: val,
                                        }
                                    }))
                                }}
                                placeholderSearch={strings.format(strings.Staff.SEARCH_TEXT, newLableStaff)}
                                onSearch={(val) => {
                                    getPagedUser({ ...model.requestDataTemp, pageNumber: 1, searchText: val })
                                }}

                                filterForm={<CardFilterForm />}
                                onReset={() => { getPagedUser() }}
                                onFilter={() => {
                                    getPagedUser({ ...model.requestDataTemp, pageNumber: 1 })
                                }}
                                onCloseFilter={() => {
                                    setModel(prev => ({ ...prev, requestDataTemp: prev.requestData }));
                                }}

                                actionList={actionList}

                                table={{
                                    rows: dataRows,
                                    columns: dataColumns,
                                }}
                            />
                        </Box>
                    </Card>
                </Grid>
            </Grid>

            {
                !Helpers.isNullOrEmpty(userIdDelete) &&
                <ModalHandelDeleteMember
                    lable={newLableStaff}
                    hidenCheckBox={hidenActionDeleteAllService}
                    openDelete={!Helpers.isNullOrEmpty(userIdDelete)}
                    params={{
                        clientId: clientId,
                        userId: userIdDelete,
                        organizationId: userInfo?.userProfile?.organizationId,
                    }}
                    onCancle={() => {
                        setUserIdDelete("");
                    }}
                    onOk={() => {
                        setUserIdDelete("");
                        getPagedUser(model.requestData);
                    }}
                />
            }

        </MainComponent>
    );
};

export default StaffListContainer;